import { render, staticRenderFns } from "./CommonReply.vue?vue&type=template&id=ac6934a0&scoped=true"
import script from "./CommonReply.vue?vue&type=script&lang=js"
export * from "./CommonReply.vue?vue&type=script&lang=js"
import style0 from "./CommonReply.vue?vue&type=style&index=0&id=ac6934a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6934a0",
  null
  
)

export default component.exports